// components/Header.tsx

import useStore from "../../store";
import GoogleChrome from "../Chrome";
import HeaderBrand from "./HeaderBrand";
import MainNav from "./MainNav";
import TopInfoBar from "./TopInfoBar";
// components/Header.tsx
export default function Header({ onOpen }: { onOpen?: () => void }) {
  const { ChromeO } = useStore();
  return (
    <div>
      {/* Top Music Bar */}
      {/* <div className="w-full bg-[#7d7d7d] text-white text-sm flex items-center justify-center px-4 py-1">
        <MusicPlayerBar />
      </div> */}
      <div className="w-full bg-[#616161] text-white text-sm flex items-center justify-center px-4 py-1">
        <TopInfoBar onOpen={onOpen} />
      </div>

      {ChromeO ? <GoogleChrome /> : false}

      {/* Main Header */}

      <div className="w-full text-white text-sm flex items-center justify-center px-4 py-1">
        <HeaderBrand  onOpen={onOpen}/>
      </div>
      <div className="w-full  border-b border-gray-200 text-white text-sm flex items-end justify-center px-4 py-1">
        <MainNav onOpenWindow={onOpen} />
      </div>
    </div>
  );
}
